import { createTestId } from 'aem-libs-tests/src/utility/createTestId'
import { inputTestIds } from 'aem-libs-tests/src/utility/inputTestIds'

import { APP_NAME } from '../constants'

const zipInputBase = createTestId(APP_NAME, 'zip-input')

export const testIds = {
  zipInputBase,
  zipInput: inputTestIds(zipInputBase),
  checkButton: createTestId(APP_NAME, 'check-button'),
  zipCheckContent: createTestId(APP_NAME, 'zip-check-content'),
  agreement: createTestId(APP_NAME, 'agreement'),
  allowedContent: createTestId(APP_NAME, 'allowed-content'),
  georgeButton: createTestId(APP_NAME, 'george-button'),
  noClientButton: createTestId(APP_NAME, 'no-client-button'),
  callMeButton: createTestId(APP_NAME, 'call-me-button'),
  notAllowedContent: createTestId(APP_NAME, 'not-allowed-content'),
}
